import axios, { AxiosResponse } from "axios";
import { body } from "./Empresas";

export default class PowerBiNode {
  private api = axios.create({
    baseURL: `${process.env.REACT_APP_API_HOST}/powerBi`,
  });

  registerWorkSpace = async (body: body, empresaId: string, url: string) => {
    const data: AxiosResponse = await this.api.post("/registerWorkspace", {
      ...body,
      empresaId,
      url,
    });
    return data.data;
  };
  getEmpresaReports = async (body: body, empresaId: string) => {
    const data: AxiosResponse = await this.api.post("/getEmpresaReports", {
      ...body,
      empresaId,
    });
    return data.data;
  };

  updateWorkspace = async (body: body, empresaId: string, workspaceId: string) => {
    const data: AxiosResponse = await this.api.post("/updateWorkspace", {
      ...body,
      empresaId,
      workspaceId,
    });
    return data.data;
  };

  manageLicenses = async (body: body, empresaId: string, updates: any) => {
    const data: AxiosResponse = await this.api.post("/manageLicences", {
      ...body,
      empresaId,
      updates,
    });
    return data.data;
  };
}
